module.exports = "<router-outlet>\n\n\n    \n</router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 24